import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  const modalContent = {
    privacy: {
      title: 'Política de Privacidad',
      content: <div className="space-y-4 text-forest/80" data-id="element-58">
          <p data-id="element-59">
            <strong data-id="element-60">Última actualización:</strong> {new Date().getFullYear()}
          </p>
          <p data-id="element-61">
            Respetamos tu privacidad y estamos comprometidos a proteger tus
            datos personales. Esta política de privacidad te informará sobre
            cómo cuidamos tus datos personales cuando visitas nuestro sitio web
            y te informará sobre tus derechos de privacidad y cómo la ley te
            protege.
          </p>
          <h3 className="text-lg font-bold text-forest mt-6" data-id="element-62">
            1. Los datos que recopilamos sobre ti
          </h3>
          <p data-id="element-63">
            Podemos recopilar, usar, almacenar y transferir diferentes tipos de
            datos personales sobre ti, que hemos agrupado de la siguiente
            manera: Datos de Identidad, Datos de Contacto, Datos Financieros,
            Datos de Transacción y Datos Técnicos.
          </p>
          <h3 className="text-lg font-bold text-forest mt-6" data-id="element-64">
            2. Cómo usamos tus datos personales
          </h3>
          <p data-id="element-65">
            Solo usaremos tus datos personales cuando la ley nos lo permita. Más
            comúnmente, usaremos tus datos personales en las siguientes
            circunstancias: para ejecutar el contrato que estamos a punto de
            celebrar o hemos celebrado contigo, o cuando sea necesario para
            nuestros intereses legítimos.
          </p>
          <h3 className="text-lg font-bold text-forest mt-6" data-id="element-66">
            3. Seguridad de los datos
          </h3>
          <p data-id="element-67">
            Hemos implementado medidas de seguridad adecuadas para evitar que
            tus datos personales se pierdan accidentalmente, se usen o se acceda
            a ellos de forma no autorizada, se alteren o se divulguen.
          </p>
        </div>
    },
    terms: {
      title: 'Términos y Condiciones',
      content: <div className="space-y-4 text-forest/80" data-id="element-68">
          <p data-id="element-69">
            <strong data-id="element-70">Última actualización:</strong> {new Date().getFullYear()}
          </p>
          <p data-id="element-71">
            Al acceder y utilizar este sitio web y nuestros productos digitales,
            aceptas estar sujeto a estos Términos y Condiciones.
          </p>
          <h3 className="text-lg font-bold text-forest mt-6" data-id="element-72">
            1. Uso del Producto
          </h3>
          <p data-id="element-73">
            El "Protocolo Vientre Plano 48H" es un producto digital de
            información. Al comprarlo, se te otorga una licencia personal, no
            exclusiva y no transferible para acceder y utilizar el contenido
            únicamente para tu uso personal. No puedes revender, distribuir ni
            compartir el material.
          </p>
          <h3 className="text-lg font-bold text-forest mt-6" data-id="element-74">
            2. Exención de Responsabilidad Médica
          </h3>
          <p data-id="element-75">
            La información proporcionada en este sitio web y en nuestros
            productos no pretende sustituir el consejo, diagnóstico o
            tratamiento médico profesional. Siempre busca el consejo de tu
            médico u otro proveedor de salud calificado con cualquier pregunta
            que puedas tener sobre una condición médica.
          </p>
          <h3 className="text-lg font-bold text-forest mt-6" data-id="element-76">
            3. Política de Reembolso
          </h3>
          <p data-id="element-77">
            Ofrecemos una garantía de satisfacción. Si no estás satisfecho con
            el producto, puedes solicitar un reembolso dentro del período de
            garantía especificado en la página de pago, sujeto a las condiciones
            establecidas por la plataforma de procesamiento de pagos.
          </p>
        </div>
    }
  };
  return <>
      <footer className="bg-forest text-sage-300/60 py-10 text-center text-sm relative z-10" data-id="element-78">
        <div className="max-w-4xl mx-auto px-4" data-id="element-79">
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-6" data-id="element-80">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold-400 transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-81">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold-400 transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-82">
              Términos y Condiciones
            </button>
          </div>

          <p data-id="element-83">
            © {new Date().getFullYear()} Protocolo Vientre Plano 48H. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-70 max-w-2xl mx-auto leading-relaxed" data-id="element-84">
            Este producto no sustituye el consejo médico profesional. Los
            resultados pueden variar. La información contenida en este sitio web
            es solo para fines educativos e informativos.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-85">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-86">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-forest/80 backdrop-blur-sm" data-id="element-87" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="relative w-full max-w-2xl bg-cream-100 rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" data-id="element-88">
              <div className="flex items-center justify-between p-6 border-b border-sage-300/30" data-id="element-89">
                <h2 className="text-2xl font-bold font-playfair text-forest" data-id="element-90">
                  {modalContent[activeModal].title}
                </h2>
                <button onClick={closeModal} className="p-2 text-forest/60 hover:text-forest hover:bg-sage-300/20 rounded-full transition-colors" aria-label="Cerrar modal" data-id="element-91">
                  <X className="w-6 h-6" data-id="element-92" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto overscroll-contain" data-id="element-93">
                {modalContent[activeModal].content}
              </div>

              <div className="p-6 border-t border-sage-300/30 bg-cream-100/50 text-right" data-id="element-94">
                <button onClick={closeModal} className="px-6 py-2 bg-forest text-cream-100 rounded-full hover:bg-forest/90 transition-colors font-medium" data-id="element-95">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}